// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserMenu_wrapper__K3cXo","selected":"UserMenu_selected__4ulRk"};